var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 51,
    viewBox: "0 0 9 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833144 50.457C0.373011 50.457 0 50.084 0 49.6239L0 1.22151C0 0.756847 0.376682 0.380165 0.841343 0.380165C1.15121 0.380165 1.43931 0.556198 1.58483 0.829773C11.5621 19.5869 11.3831 30.5177 1.5783 49.9947C1.43723 50.2749 1.14688 50.457 0.833144 50.457Z",
    fill: "#0226BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarActive);
export default __webpack_public_path__ + "static/media/SideBarActive.8fbecf20d93b973591114149aba3a015.svg";
export { ForwardRef as ReactComponent };